



















import {defineComponent, ref, watchEffect} from "@vue/composition-api"

export default defineComponent({
  name: 'Slider',
  props: {
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  setup({min, max}, {emit}) {
    const selected = ref((max + min) / 2)

    watchEffect(() => {
      emit('value', selected.value)
    })

    return {
      selected
    }
  }
})
